define.alias("shared/utils/object-methods/object-map", "media/utils/object-methods/object-map");